module.exports = __webpack_public_path__ + "img/case-placeholder.ed043276.svg";